import { render, staticRenderFns } from "./PreviewForm2.vue?vue&type=template&id=0958102a&scoped=true"
import script from "./PreviewForm2.vue?vue&type=script&lang=ts"
export * from "./PreviewForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958102a",
  null
  
)

export default component.exports